import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {
  Document,
  EntityType,
  Equipment,
  FilterCardData,
  GeneralFilter,
  Partner,
  ServiceOrder,
  TableColumn,
  ToastConfig,
  SortDirection,
  ConfirmationModalComponent,
  ConfirmationModalConfig
} from '@app/shared';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {
  EquipmentDetailDrawerComponent
} from '../../../drawers/equipment-detail-drawer/equipment-detail-drawer.component';
import {AsignEquipmentDrawerComponent} from '../../../drawers/asign-equipment-drawer/asign-equipment-drawer.component';
import {
  EquipmentService,
  getItemById,
  getSafeImageUrl,
  isExpirationAlert,
  ScreenService,
  StServiceService
} from '@app/core';
import {combineLatest, finalize, take} from 'rxjs';
import {DocDrawerComponent} from '../../../../../shared/components/doc-drawer/doc-drawer.component';
import {DocModalComponent} from '../../../../../shared/components/doc-modal/doc-modal.component';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {GlobalValuesService} from '../../../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthService} from '../../../../../core/services/auth.service';
import {ProjectUtilsService} from '../../../services/project-utils.service';
import {ProjectSortService} from '../../../services/project-sort.service';

@Component({
  selector: 'app-equipment-table',
  standalone: false,

  templateUrl: './equipment-table.component.html',
  styleUrl: './equipment-table.component.less'
})
export class EquipmentTableComponent implements OnInit, OnDestroy {

  @Input() isAsigning: boolean = false;
  @Input() serviceOrder: ServiceOrder | undefined;
  @Input() isServiceOrder: boolean = false;
  @Input() disableAsignEquipments: boolean = false;
  @Input() equipments: Equipment[] = [];
  @Output() selectedEquipmentsEvent = new EventEmitter<Set<number>>();
  @Output() equipmentsChanged = new EventEmitter<Equipment[]>();

  @ViewChild('confirmationModal') confirmationModal!: ConfirmationModalComponent;

  getSafeImageUrl = getSafeImageUrl;

  equipmetUrl = window.location.origin + '/maestro/equipment';
  selectedEquipmentsIds = new Set<number>();
  filteredEquiments: Equipment[] = [];
  equipmentsWithImageError: number[] = [];

  docDrawer: any;
  uploadDocsDrawerRef: any;
  uploadDocsModalRef: any;

  card: FilterCardData = {
    active: false,
  };
  equipmentStates = ['Available', 'Busy'];
  equipmentTypes = ['Truck', 'Crane', 'Driver'];
  equipmentStateFilterValue: string = '';
  equipmentTypeFilterValue: string = '';
  equipmentSearchValue: string = '';
  equipmentFilters: GeneralFilter[] = [
    {name: 'Tipo', active: false, icon: 'arrow_drop_down'},
    // {name: 'Estado', active: false, icon: 'arrow_drop_down'},
  ];

  equimentDetailDrawer: any;
  asignEquimentDetailDrawer: any;
  /** Columnas de la tabla **/
  columns: TableColumn[] = [
    {
      name: '',
      width: '65',
      checkbox: true,
      align: 'center'
    },
    {
      name: 'Tipo',
      pathData: { name: 'equipmentTypeId', type: 'select', nestedPath: 'name' },
      width: '120',
      align: 'left',
    },
    {
      name: 'Matricula',
      pathData: { name: 'name', type: 'text' },
      width: '140',
      align: 'left'
    },
    {
      name: 'Propietario',
      pathData: { name: 'ownerId', type: 'avatar-select', nestedPath: 'name' },
      width: '180',
      align: 'left'
    },
    {
      name: 'Contacto asociado',
      pathData: { name: 'contactId', type: 'avatar-select', nestedPath: 'name' },
      width: '180',
      align: 'left'
    },
    {
      name: 'Documentación',
      pathData: { name: 'documents', type: 'multi-select' },
      width: '458',
      align: 'left'
    },
  ];

  showInput: boolean = false;
  showFilters: boolean = false;

  isMobile$;

  partnerList: Partner[] = [];

  unasignLoading = false;
  singleEquipmentToUnassign: number | null = null;
  // Toast configuration
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Equipos desvinculados.',
    showUndo: false
  };
  notRef: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  protected readonly getItemById = getItemById;
  protected readonly isExpirationAlert = isExpirationAlert;

  constructor(private drawerService: NzDrawerService, private screenService: ScreenService,
              public gs: GlobalValuesService, public authService: AuthService,
              public ps: ProjectUtilsService, private stServiceService: StServiceService,
              private modalService: NzModalService, private changeDetectorRef: ChangeDetectorRef,
              private notificationService: NzNotificationService, private equipmentService: EquipmentService,
              private projectSortService: ProjectSortService) {
    this.isMobile$ = screenService.isMobile$;
    gs.isPartnerReady$.pipe(takeUntilDestroyed()).subscribe(value => {
      if (value) {
        this.partnerList = gs.partnerlist;
        // Configurar ordenamiento para columnas con datos asíncronos
        this.projectSortService.setupSortWhenOptionListReady(
          this.columns, 'Tipo', gs.equipmentTypes$.value, (col) => this.handleSort(col)
        );
        this.projectSortService.setupSortWhenOptionListReady(
          this.columns, 'Propietario', gs.partnerlist, (col) => this.handleSort(col)
        );
        this.projectSortService.setupSortWhenOptionListReady(
          this.columns, 'Contacto asociado', gs.partnerlist, (col) => this.handleSort(col)
        );
      }
    });

    this.ps.closeAllDrawers$.pipe(takeUntilDestroyed()).subscribe(value => {
      if (value) {
        this.docDrawer?.close();
        this.uploadDocsDrawerRef?.close();
        this.uploadDocsModalRef?.close();
        this.equimentDetailDrawer?.close();
        this.asignEquimentDetailDrawer?.close();
      }
    })
  }

  // Saber si todos estan seleccionados
  get isAllSelected(): boolean {
    if (this.isAsigning) {
      const activeItems = this.filteredEquiments.filter(item => item.isActive);
      return activeItems.every(item => this.selectedEquipmentsIds.has(item.id));
    }
    return this.filteredEquiments.every(item => this.selectedEquipmentsIds.has(item.id));
  }

  // Saber si solo algunos estan seleccionados
  get isIndeterminate(): boolean {
    const hasSelected = this.filteredEquiments.some(item =>
      this.selectedEquipmentsIds.has(item.id)
    );
    return !this.isAllSelected && hasSelected;
  }

  ngOnInit() {
    this.filter();
    this.configureSortFunctions();
  }

  /** Drawers **/
  openEquipmentDetailDrawer(equipment: Equipment): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.equimentDetailDrawer = this.drawerService.create({
        nzClosable: false,
        nzMask: false,
        nzWidth: 900,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzContent: EquipmentDetailDrawerComponent,
        nzData: {
          equipment,
        }
      });
    });

  }

  openAsignEquipmentDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.asignEquimentDetailDrawer = this.drawerService.create({
        nzClosable: false,
        nzMask: true,
        nzWidth: 952,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzContent: AsignEquipmentDrawerComponent,
        nzData: {
          serviceOrder: this.serviceOrder || undefined,
        }
      });

      this.asignEquimentDetailDrawer.afterClose.subscribe(() => {
        if (this.serviceOrder) {
          this.equipments = [...this.serviceOrder.equipments || []];
        } else {
          this.equipments = [...this.ps.selectedService!.equipments || []]
        }
        this.filter();
        this.changeDetectorRef.detectChanges();
      });
    });
  }

  /** Logica de seleccion de Equipos **/

  // Alternamiento individual
  toggleSelectEquipment(id: number): void {
    if (this.selectedEquipmentsIds.has(id)) {
      this.selectedEquipmentsIds.delete(id);
    } else {

      this.selectedEquipmentsIds.add(id);
    }

    this.selectedEquipmentsEvent.emit(this.selectedEquipmentsIds);
  }

  // Alternamiento total
  toggleSelectAllEquipments(): void {
    const newSet = new Set(this.selectedEquipmentsIds);

    // Si se esta asignando al seleccionar todos solo se escogeran los Activos
    const itemsToProcess = this.isAsigning
      ? this.filteredEquiments.filter(item => item.isActive)
      : this.filteredEquiments;

    if (this.isAllSelected) {
      itemsToProcess.forEach(item => newSet.delete(item.id));
    } else {
      itemsToProcess.forEach(item => newSet.add(item.id));
    }

    this.selectedEquipmentsIds = newSet;
    this.selectedEquipmentsEvent.emit(this.selectedEquipmentsIds);
  }

  /** Filtros **/
  toggleSelectedFilter(): void {
    this.card.active = !this.card.active;
    this.filter();
  }

  setStateFilter(state: string): void {
    if (state === this.equipmentStateFilterValue) {
      this.equipmentStateFilterValue = '';
      this.equipmentFilters.find(f => f.name === 'Estado')!.active = false;
    } else {
      this.equipmentStateFilterValue = state;
      this.equipmentFilters.find(f => f.name === 'Estado')!.active = true;
    }
    this.filter();
  }

  setTypeFilter(type: string): void {
    if (type === this.equipmentTypeFilterValue) {
      this.equipmentTypeFilterValue = '';
      this.equipmentFilters.find(f => f.name === 'Tipo')!.active = false;
    } else {
      this.equipmentTypeFilterValue = type;
      this.equipmentFilters.find(f => f.name === 'Tipo')!.active = true;
    }
    this.filter();
  }

  // Aqui iran los filtros de estados, tipos y seleccionados
  filter(): void {
    // Inicializacion del filtro temporal
    let tempFilter = this.equipments;

    this.equipmentTypes = Array.from(
      new Set(
        tempFilter
          .map(e => e.equipmentType?.name)
          .filter(name => name !== undefined)
      )
    );

    this.equipmentStates = Array.from(
      new Set(
        tempFilter.map(e => e.state)
      )
    );

    // Filtrado por seleccionados
    if (this.card.active) {
      tempFilter = tempFilter.filter(e => this.selectedEquipmentsIds.has(e.id));
    }

    // Filtrado por estado
    if (this.equipmentStateFilterValue !== '') {
      tempFilter = tempFilter.filter(e => e.state === this.equipmentStateFilterValue);
    }

    // Filtrado por tipo
    if (this.equipmentTypeFilterValue !== '') {
      tempFilter = tempFilter.filter(e => e.equipmentType?.name === this.equipmentTypeFilterValue);
    }

    if (this.equipmentSearchValue || this.equipmentSearchValue === '') {
      tempFilter = tempFilter.filter(e => e.name.toLowerCase().includes(this.equipmentSearchValue.toLowerCase()));
    }

    this.filteredEquiments = tempFilter;
  }

  toggleShowInput(): void {
    this.showFilters = false;
    this.showInput = !this.showInput;
  }

  toggleShowFilters(): void {
    this.showInput = false;
    this.showFilters = !this.showFilters;
  }

  /** Metodos de documentos **/
  // Abrir drawer de documento
  openDocDrawer(doc: Document, equipment: Equipment): void {
    this.docDrawer?.close();
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.docDrawer = this.drawerService.create({
        nzWidth: 635,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzClosable: false,
        nzMask: false,
        nzContent: DocDrawerComponent,
        nzData: {
          document: doc,
        }
      });

      // Espera a que el drawer esté completamente abierto
      this.docDrawer.afterOpen.pipe(take(1)).subscribe(() => {
        this.docDrawer.getContentComponent().deleteEvent.pipe(take(1)).subscribe((docs: Document[]) => {
          equipment.documents = equipment.documents!.filter(d => !docs.includes(d));
        });
      });
    });
  }

  // Abrir el modal de upload documentos
  openUploadDocsModal(entityId: number, entityType: EntityType, equipment: Equipment): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      if (isMobile) {
        this.uploadDocsDrawerRef = this.drawerService.create({
          nzClosable: false,
          nzMask: false,
          nzHeight: '98%',
          nzPlacement: 'bottom',
          nzContent: DocModalComponent,
          nzData: {
            docModalType: 'upload',
            entityId,
            entityType,
          }
        });

      } else {
        this.uploadDocsModalRef = this.modalService.create({
          nzFooter: null,
          nzContent: DocModalComponent,
          nzClosable: false,
          nzAutofocus: null,
          nzCentered: true,
          nzClassName: 'mobile-drawerlike',
          nzWidth: 'auto'
        });

        this.uploadDocsModalRef.getContentComponent().docModalType = 'upload';
        this.uploadDocsModalRef.getContentComponent().entityId = entityId;
        this.uploadDocsModalRef.getContentComponent().entityType = entityType;

        // Espera a que el drawer esté completamente abierto
        this.uploadDocsModalRef.afterOpen.pipe(take(1)).subscribe(() => {
          this.uploadDocsModalRef.getContentComponent().createEvent.pipe(take(1)).subscribe((docs: Document[]) => {
            equipment.documents = [...equipment.documents || [], ...docs];
          });
        });
      }
    });
  }

  deleteDocument(equipment: Equipment, doc: Document) {
    equipment.documents = [...equipment.documents!.filter(d => d.id !== doc.id) || []]
  }

  handleImageError(equipmentId: number) {
    this.equipmentsWithImageError.push(equipmentId);
  }

  isThisEquipmentWIthErrorImg(equipmentId: number): boolean {
    return this.equipmentsWithImageError.includes(equipmentId);
  }

  ngOnDestroy() {
    this.docDrawer?.close();
    this.uploadDocsDrawerRef?.close();
    this.uploadDocsModalRef?.close();
    this.equimentDetailDrawer?.close();
    this.asignEquimentDetailDrawer?.close();
  }

  openUnassignConfirmation() {
    const config: ConfirmationModalConfig = {
      title: 'Desvincular equipos',
      message: '¿Seguro que desea desvincular los equipos seleccionados?',
      confirmText: 'Desvincular',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: true
    };
    this.confirmationModal.config = config;
    this.confirmationModal.open();
  }

  openUnassignEquipmentConfirmation(equipmentId: number) {
    const config: ConfirmationModalConfig = {
      title: 'Desvincular equipo',
      message: '¿Seguro que desea desvincular este equipo?',
      confirmText: 'Desvincular',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: true
    };
    this.confirmationModal.config = config;
    this.confirmationModal.open();

    // Guardar el ID del equipo para usar en la confirmación
    this.singleEquipmentToUnassign = equipmentId;
  }

  onUnassignConfirmed(data: {textValue?: string, dateValue?: Date}) {
    this.unasignLoading = true;
    // Actualizar el estado del modal para mostrar loading
    this.confirmationModal.config.processing = true;

    if (this.singleEquipmentToUnassign !== null) {
      // desvincular un solo equipo
      this.unasignSingleEquipment(this.singleEquipmentToUnassign);
      this.singleEquipmentToUnassign = null;
    } else {
      // Desvincular múltiples equipos
      this.unasignEquipments();
    }
  }

  unasignEquipments() {
    this.unasignLoading = true;

    // Si es la seccion de SO
    if (this.serviceOrder) {
      const remainEquipmentsIds = (this.serviceOrder!.equipments || [])
        .filter(e => !this.selectedEquipmentsIds.has(e.id))
        .map(e => e.id);

      const selectedEquipmentsCount = this.selectedEquipmentsIds.size;

      this.stServiceService.patchServiceOrder(
        {
          id: this.serviceOrder.id,
          equipmentIds: remainEquipmentsIds,
        }
      )
        .pipe(finalize(() => {
          this.unasignLoading = false;
          this.confirmationModal.config.processing = false;
          this.confirmationModal.forceClose();
          this.notRef = this.notificationService
            .create("blank", '', this.notificationTmpl, {nzPlacement: "bottomRight"});
        }))
        .subscribe({
          next: () => {
            this.serviceOrder!.equipmentIds = remainEquipmentsIds;
            this.serviceOrder!.equipments = [...(this.serviceOrder!.equipments || []).filter(e => !this.selectedEquipmentsIds.has(e.id))];
            this.equipments = this.serviceOrder!.equipments;
            this.selectedEquipmentsIds.clear();
            this.filter();
            this.changeDetectorRef.detectChanges();

            // Limpiar selecciones
            this.selectedEquipmentsIds.clear();
            this.selectedEquipmentsEvent.emit(this.selectedEquipmentsIds);

            // Emitir cambio en la lista de equipos
            this.equipmentsChanged.emit(this.equipments);

            // Configurar toast de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: `Se desvincularon ${selectedEquipmentsCount} equipo(s)`,
              showUndo: false
            };
          },
          error: (error) => {
            console.error('Error al desvincular equipos:', error);

            // Configurar toast de error
            this.toastConfig = {
              icon: 'dangerous',
              iconColor: '#CB2A2F',
              content: 'Error al desvincular los equipos',
              msg: error?.error?.message || 'Error interno del servidor',
              showUndo: false
            };
          }
        });

    } else {
      this.equipmentService.deleteEquipmentService({
        serviceId: this.ps.selectedService!.id,
        equipmentsIds: Array.from(this.selectedEquipmentsIds)
      })
        .pipe(finalize(() => {
          this.unasignLoading = false;
          this.confirmationModal.config.processing = false;
          this.confirmationModal.forceClose();
          this.notRef = this.notificationService
            .create("blank", '', this.notificationTmpl, {nzPlacement: "bottomRight"});
        }))
        .subscribe({
          next: () => {
            this.equipments = this.equipments.filter(e => !this.selectedEquipmentsIds.has(e.id));
            this.ps.selectedService!.equipments = this.equipments;
            this.selectedEquipmentsIds.clear();
            this.filter();
            this.changeDetectorRef.detectChanges();

            // Limpiar selecciones
            this.selectedEquipmentsIds.clear();

            // Emitir cambio en la lista de equipos
            this.equipmentsChanged.emit(this.equipments);

            // Configurar toast de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: `Se desvincularon los equipos`,
              showUndo: false
            };
          },
          error: (error) => {
            console.error('Error al desvincular equipos:', error);

            // Configurar toast de error
            this.toastConfig = {
              icon: 'dangerous',
              iconColor: '#CB2A2F',
              content: 'Error al desvincular los equipos',
              msg: error?.error?.message || 'Error interno del servidor',
              showUndo: false
            };
          },
        })
    }
  }

  unasignSingleEquipment(equipmentId: number) {
    this.unasignLoading = true;

    // Si es la seccion de SO
    if (this.serviceOrder) {
      const remainEquipmentsIds = (this.serviceOrder!.equipments || [])
        .filter(e => e.id !== equipmentId)
        .map(e => e.id);

      this.stServiceService.patchServiceOrder(
        {
          id: this.serviceOrder.id,
          equipmentIds: remainEquipmentsIds,
        }
      )
        .pipe(finalize(() => {
          this.unasignLoading = false;
          this.confirmationModal.config.processing = false;
          this.confirmationModal.forceClose();
          this.notRef = this.notificationService
            .create("blank", '', this.notificationTmpl, {nzPlacement: "bottomRight"});
        }))
        .subscribe({
          next: () => {
            this.serviceOrder!.equipmentIds = remainEquipmentsIds;
            this.serviceOrder!.equipments = [...(this.serviceOrder!.equipments || []).filter(e => e.id !== equipmentId)];
            this.equipments = this.serviceOrder!.equipments;
            this.filter();
            this.changeDetectorRef.detectChanges();

            // Emitir cambio en la lista de equipos
            this.equipmentsChanged.emit(this.equipments);

            // Configurar toast de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Equipo desasociado correctamente',
              showUndo: false
            };
          },
          error: (error) => {
            console.error('Error al desvincular equipo:', error);

            // Configurar toast de error
            this.toastConfig = {
              icon: 'dangerous',
              iconColor: '#CB2A2F',
              content: 'Error al desvincular el equipo',
              msg: error?.error?.message || 'Error interno del servidor',
              showUndo: false
            };
          }
        });

    } else {
      this.equipmentService.deleteEquipmentService({
        serviceId: this.ps.selectedService!.id,
        equipmentsIds: [equipmentId]
      })
        .pipe(finalize(() => {
          this.unasignLoading = false;
          this.confirmationModal.config.processing = false;
          this.confirmationModal.forceClose();
          this.notRef = this.notificationService
            .create("blank", '', this.notificationTmpl, {nzPlacement: "bottomRight"});
        }))
        .subscribe({
          next: () => {
            this.equipments = this.equipments.filter(e => e.id !== equipmentId);
            this.ps.selectedService!.equipments = this.equipments;
            this.filter();
            this.changeDetectorRef.detectChanges();

            // Emitir cambio en la lista de equipos
            this.equipmentsChanged.emit(this.equipments);

            // Configurar toast de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Equipo desasociado correctamente',
              showUndo: false
            };
          },
          error: (error) => {
            console.error('Error al desvincular equipo:', error);

            // Configurar toast de error
            this.toastConfig = {
              icon: 'dangerous',
              iconColor: '#CB2A2F',
              content: 'Error al desvincular el equipo',
              msg: error?.error?.message || 'Error interno del servidor',
              showUndo: false
            };
          },
        })
    }
  }

  // Métodos de ordenamiento
  private configureSortFunctions(): void {
    this.projectSortService.configureSortFunctions(this.columns, (column) => this.handleSort(column));
  }

  private handleSort(column: TableColumn): void {
    if (!column.pathData) return;

    const { sortedData } = this.projectSortService.handleSort(column, this.filteredEquiments, this.columns);
    this.filteredEquiments = sortedData;
  }

  getColumnSortDirection(column: TableColumn): SortDirection {
    return column.sortDirection || null;
  }
}
